import { render } from "./RequestReceived.vue?vue&type=template&id=28975828"
import script from "./RequestReceived.vue?vue&type=script&lang=js"
export * from "./RequestReceived.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__